module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_funabashi-64ac3b7542618ad8b60501684d537ccf.jpg";